// extracted by mini-css-extract-plugin
module.exports = {"loading_container":"SimpleActivity_loading_container__DOtMP","loadingContainer":"SimpleActivity_loading_container__DOtMP","accessDenied":"SimpleActivity_accessDenied__1-3Yy"};